import { TFilter } from 'utils/context/FilterContext/types';
import { isEmpty } from 'utils/context/FilterContext/utils';
import DK from 'utils/dictionaries/filter_dictionary';

import { IBasicInventoryOrderSearchCriteria } from '@project44-models/shipment-list';

const mapDate = (startTime?: string, endTime?: string) => {
  if (!startTime || !endTime) {
    return [];
  }
  return [
    [
      DK.PLANNED_DATETIME,
      DK.WITHIN,
      [
        new Date(startTime).getTime().toString(),
        new Date(endTime).getTime().toString(),
      ],
    ],
  ];
};

export const paramsFromOrder = (
  view: IBasicInventoryOrderSearchCriteria,
): TFilter => {
  if (!view) {
    return {};
  }

  const properties = [
    view.orderAttributes?.length && DK.ORDER_REFERENCE_KEY,
  ].filter(Boolean);

  const orderReferenceKey = [
    ...(view.orderAttributes?.map((attribute) => [
      attribute.name,
      DK[attribute.operator],
      attribute.values,
    ]) || []),
  ];

  const params = {
    [DK.ORDER_PROPERTIES]: properties,
    [DK.SEARCH_TEXT]: view.searchText,
    [DK.ORDER_TYPE]: view.orderTypes?.map((type: string) => DK[type]),
    [DK.ORDER_STATUS]: view.statusCodes?.map((type: string) => DK[type]),
    [DK.DATES]: [
      view.orderSubmissionDateTime && DK.ORDER_SUBMISSION_DATE,
      view.originalDeliveryDateTimeWindowStart && DK.ORDER_DUE_DATE,
      view.supplierReadyDateTimeWindowStart && DK.SUPPLIER_READY_DATE,
    ].filter(Boolean),
    [DK.ORDER_SUBMISSION_DATE]: mapDate(
      view.orderSubmissionDateTime?.startDateTime,
      view.orderSubmissionDateTime?.endDateTime,
    ),
    [DK.ORDER_DUE_DATE]: mapDate(
      view.originalDeliveryDateTimeWindowStart?.startDateTime,
      view.originalDeliveryDateTimeWindowStart?.endDateTime,
    ),
    [DK.SUPPLIER_READY_DATE]: mapDate(
      view.supplierReadyDateTimeWindowStart?.startDateTime,
      view.supplierReadyDateTimeWindowStart?.endDateTime,
    ),
    [DK.ORDER_REFERENCE_KEY]: orderReferenceKey,
  } as TFilter;

  // TODO Fix after gateway update
  // if (view.paging) {
  //   const [sort, direction] = view.paging.sort.split(':');
  // }

  Object.keys(params).forEach((key) => {
    if (isEmpty(params[key])) {
      delete params[key];
    }
  });

  return params;
};
